module.exports = __webpack_public_path__ + "img/steel-processing.040e680f.png";